module.exports = __webpack_public_path__ + "assets/img/client.4bb3b3c6.svg";